import { configureStore } from "@reduxjs/toolkit";
import postsReducer from "../features/posts/postsSlice";
import relatedPostsReducer from "../features/relatedPosts/relatedPostsSlice";
import postReducer from "../features/post/postSlice";
import filterReducer from "../features/filters/filterSlice";

export const store = configureStore({
    reducer: {
        posts: postsReducer,
        relatedPosts: relatedPostsReducer,
        post: postReducer,
        filters: filterReducer,
    },
});